import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined'
import { Button, Typography } from '@mui/material'
import type { ReactNode } from 'react'
import styles from './PageBackHeader.module.scss'

type PageBackHeaderProps = Readonly<{
  backLabel: string
  children: ReactNode
  onBack: () => void
  subtitle?: ReactNode
}>

export function PageBackHeader({ backLabel, children, onBack, subtitle }: PageBackHeaderProps) {
  return (
    <header className={styles.header}>
      <Button
        aria-label={`Back to ${backLabel}`}
        className={styles.backLink}
        onClick={onBack}
        startIcon={<ChevronLeftOutlinedIcon />}
      >
        {backLabel}
      </Button>
      <div className={styles.title}>
        {children}
        {subtitle ? <Typography className={styles.subtitle} color="text.secondary">{subtitle}</Typography> : null}
      </div>
    </header>
  )
}
